import React, { useContext, useState, useEffect } from 'react'
import ModalContext from '../../contexts/ModalContext'
import StockContext from '../../contexts/StockContext'
import {
  Container,
  HeaderText,
  InputRowDiv,
  InputDiv,
  InputLabel,
  ButtonsDiv,
  EditButtonDiv,
  ButtonImage,
  ButtonImageCertificate,
  ButtonText,
  MovimentButtonDiv,
  MovimentButtonImage,
  CertificateButtonDiv,
  CloseDiv,
  CloseImg,
  SwitchButton,
  ScrollDiv,
} from './style'
import {
  FieldsToHeaders,
  fieldsToHeaders,
  StockInterface,
} from '../../pages/ClientPanel/Stock/StockTable/utils'
import editPen from '../../assets/edit-pen.svg'
import activeCert from '../../assets/orders/certificate-active.svg'
import cross from '../../assets/addStockModal/cross.svg'
import doubleArrow from '../../assets/doubleArrow.svg'
import axios from 'axios'
import CertificatesContext from '../../contexts/CertificatesContext'
import { Info } from 'lucide-react'
import { Button } from '../styles/modal-style'

const newModal = () => {
  const { setModalActive, setModalSection, setItIsUpdate } =
    useContext(ModalContext)
  const { stock, setStock } = useContext(StockContext)
  const { setCertificate } = useContext(CertificatesContext)
  const [activeMenu, setActiveMenu] = useState(0)

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target

    setStock({
      ...stock,
      [name]: value,
    })
  }

  const fieldsArray: string[][] = [
    ['material', 'code'],
    ['format', 'finishing'],
    ['dimension1', 'dimension2'],
    ['lengthInMm', 'quantity'],
    ['totalWeight', 'costPerKg'],
    ['fabrication', 'heatTreatment'],
    ['density', 'heatNumber'],
    ['receivedDate', 'originCountry'],
    ['stockStreet', 'stockLocation'],
    ['purchaseOrder', 'trackingNumber'],
    ['ncm', 'family'],
    ['supplier', 'shelf'],
    ['measurementUnit', 'costPerMm'],
]

  const modalEdit = () => {
    setItIsUpdate(true)
    setModalActive(true)
    setModalSection('firstCustomAdd')
  }

  const newMoviment = () => {
    setItIsUpdate(true)
    setModalActive(true)
    setModalSection('modalEntryOrExit')
  }

  /*const openChangeCodeModal = () => {
    setItIsUpdate(true)
    setModalActive(true)
    setModalSection('changeCodeModal')
  }*/

  const certificate = () => {
    setModalSection('viewCertificate')
  }

  const handleCheckCertificate = async (certificateId: number) => {
    const certificateUrl = `${process.env.REACT_APP_GATEWAY_BASE_URL}/certificates`
    axios
      .get(`${certificateUrl}/certificate/${certificateId}`)
      .then((response) => {
        setModalActive(true)
        setModalSection('viewCertificate')
        setCertificate(response.data)
      })
      .catch((error) => {
        console.error(error)
      })
  }

  const handleSwitchActivation = async () => {
    console.log('🔄 [ACTIVATION] Iniciando alteração de status:', {
      stockId: stock.id,
      stockIdType: typeof stock.id,
      currentStatus: stock.isActivated,
      currentStatusType: typeof stock.isActivated
    })
    
    // Envia o ID do stock e o novo estado (oposto ao atual) para a API
    const newActivationStatus = !stock.isActivated
    
    const requestBody = {
      id: Number(stock.id), // Garantindo que é um número
      isActivated: Boolean(newActivationStatus), // Garantindo que é um booleano
    }
    
    console.log('📤 [ACTIVATION] Dados sendo enviados:', {
      requestBody,
      idType: typeof requestBody.id,
      isActivatedType: typeof requestBody.isActivated
    })
    
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_GATEWAY_BASE_URL}/backend/stock/activateStock`,
        requestBody
      )

      console.log('✅ [ACTIVATION] Resposta recebida:', {
        status: response.status,
        data: response.data
      })

      // Atualiza o estado local 'stock' com o novo valor
      setStock(response.data.data) // A resposta da API deve conter o objeto Stock atualizado
      console.log(
        'Status de ativação alterado com sucesso:',
        response.data.data,
      )
    } catch (error: any) {
      console.error('❌ [ACTIVATION] Erro ao mudar status de ativação:', {
        error,
        message: error.message,
        status: error.response?.status,
        data: error.response?.data
      })
      alert('Erro ao mudar status de ativação.')
    }
  }

  return (
    <Container>
      <HeaderText>{stock.description}</HeaderText>
      <CloseDiv onClick={() => setModalActive(false)}>
        <CloseImg src={cross} alt='Close tab' />
      </CloseDiv>
      <ScrollDiv>
      {fieldsArray.map((inputRow, rowIndex) => (
        <InputRowDiv key={rowIndex}>
          {inputRow.map((stockField: string, colIndex) => (
            <InputDiv key={colIndex}>
              <InputLabel htmlFor={stockField}>
                {fieldsToHeaders[stockField as keyof FieldsToHeaders]}:
              </InputLabel>
              {/* <span>{fieldsToHeaders[stockField as keyof FieldsToHeaders]}:</span> */}
              <p className='ml-2'>
                {stock[stockField as keyof StockInterface] || 'N/A'}
              </p>
            </InputDiv>
          ))}
        </InputRowDiv>
      ))}
      </ScrollDiv>
      <ButtonsDiv>
        {/* Botão de Ativar/Inativar */}
        <Button onClick={handleSwitchActivation}>
          {stock.isActivated ? 'Inativar' : 'Ativar'}
        </Button>
        <EditButtonDiv onClick={modalEdit} disabled={!stock.isActivated}>
          <ButtonImage src={editPen} />
          <ButtonText>Editar</ButtonText>
        </EditButtonDiv>

        <MovimentButtonDiv onClick={newMoviment} disabled={!stock.isActivated}>
          <MovimentButtonImage src={doubleArrow} />
          <ButtonText>Novo movimento</ButtonText>
        </MovimentButtonDiv>
      </ButtonsDiv>
    </Container>
  )
}

export default newModal
